"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BreadcrumbLink = require("./BreadcrumbLink");
Object.keys(_BreadcrumbLink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BreadcrumbLink[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BreadcrumbLink[key];
    }
  });
});
var _Breadcrumbs = require("./Breadcrumbs");
Object.keys(_Breadcrumbs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Breadcrumbs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Breadcrumbs[key];
    }
  });
});